import type {
  CreateZoneRequest,
  ListZonesResponse,
  UpdateZoneRequest,
  ZoneResponse,
  ZoneStatus,
} from '@jq4race/shared';

import { request } from './client.js';

export async function listZones(
  locationId: string,
  params?: { status?: ZoneStatus },
): Promise<ListZonesResponse> {
  const qs = params?.status ? `?status=${encodeURIComponent(params.status)}` : '';
  return request<ListZonesResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/zones${qs}`,
    { method: 'GET' },
  );
}

export async function createZone(
  locationId: string,
  input: CreateZoneRequest,
): Promise<ZoneResponse> {
  return request<ZoneResponse>(`/admin/locations/${encodeURIComponent(locationId)}/zones`, {
    method: 'POST',
    body: input,
  });
}

export async function getZone(locationId: string, zoneId: string): Promise<ZoneResponse> {
  return request<ZoneResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/zones/${encodeURIComponent(zoneId)}`,
    { method: 'GET' },
  );
}

export async function updateZone(
  locationId: string,
  zoneId: string,
  input: UpdateZoneRequest,
): Promise<ZoneResponse> {
  return request<ZoneResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/zones/${encodeURIComponent(zoneId)}`,
    { method: 'PATCH', body: input },
  );
}

export async function deactivateZone(locationId: string, zoneId: string): Promise<ZoneResponse> {
  return request<ZoneResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/zones/${encodeURIComponent(zoneId)}/deactivate`,
    { method: 'POST' },
  );
}

export async function activateZone(locationId: string, zoneId: string): Promise<ZoneResponse> {
  return request<ZoneResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/zones/${encodeURIComponent(zoneId)}/activate`,
    { method: 'POST' },
  );
}
